<!--zx_frame_db.auth_zx_user（用户表）-table-->
<!--参数添加，1、config.js business中添加：zxUser: '后台地址'-->
<!--参数添加，2、global.js businessFlag中添加：zxUser: 'zxUser'-->
<template>
  <div class="main-area">
    <el-breadcrumb separator=":">
      <el-breadcrumb-item>当前位置</el-breadcrumb-item>
      <el-breadcrumb-item>用户列表</el-breadcrumb-item>
    </el-breadcrumb>
    <!--查询区域-->
    <el-row class="margin-top-10">
      <el-col :span="2" class="margin-top-10">
        <label class="search-label">
          姓名:
        </label>
      </el-col>
      <el-col :span="4" class="margin-top-10">
        <el-input v-model="searchForm.xm"
                  :size="GLOBAL.config.systemSize"
                  placeholder="姓名"
                  maxlength="32" clearable></el-input>
      </el-col>
      <el-col :span="2" class="margin-top-10">
        <label class="search-label">
          身份证号:
        </label>
      </el-col>
      <el-col :span="4" class="margin-top-10">
        <el-input v-model="searchForm.sfzh"
                  :size="GLOBAL.config.systemSize"
                  placeholder="身份证号"
                  maxlength="32" clearable></el-input>
      </el-col>
      <el-col :span="2" class="margin-top-10">
        <label class="search-label">
          手机号:
        </label>
      </el-col>
      <el-col :span="4" class="margin-top-10">
        <el-input v-model="searchForm.sjh"
                  :size="GLOBAL.config.systemSize"
                  placeholder="手机号"
                  maxlength="32" clearable></el-input>
      </el-col>
      <el-col :span="2" class="margin-top-10">
        <label class="search-label">
          角色:
        </label>
      </el-col>
      <el-col :span="4" class="margin-top-10">
        <el-select v-model="searchForm.yhlx"
                   :size="GLOBAL.config.systemSize"
                   placeholder="角色"
                   style="width: 100%;" clearable
        >
          <!-- <el-option label="--请选择--" value=""></el-option> -->
          <el-option :label="item.text2" :value="item.uuid"
                     v-for="item in rolesData"
                     :key="item.uuid"></el-option>
        </el-select>
      </el-col>
    </el-row>
    <el-row class="margin-top-20">
      <el-col :span="2">
        <label class="search-label">区划:</label>
      </el-col>
      <el-col :span="4">
        <cascader :set-props="setProps"
                  :set-size="GLOBAL.config.systemSize" maxlength="64"
                  ref="myArea">
        </cascader>
      </el-col>
      <el-col :span="12">
        <el-button type="primary"
                   @click="doSearch"
                   :size="GLOBAL.config.systemSize"
                   style="float: left; margin-left: 10px;"
                   icon="el-icon-search">查询
        </el-button>
        <el-button v-if="source.add"
                   type="primary"
                   icon="el-icon-plus"
                   :size="GLOBAL.config.systemSize"
                   style="float: left;"
                   @click="operationMethod('add')">新增
        </el-button>
        <el-button type="primary"
                   icon="el-icon-download"
                   :size="GLOBAL.config.systemSize"
                   style="float: left;"
                   @click="exportFile">导出
        </el-button>
        <el-button v-if="false"
                   type="primary"
                   :size="GLOBAL.config.systemSize"
                   style="float: left;"
                   @click="menuManager('1')">县管理员菜单
        </el-button>
        <el-button v-if="false"
                   type="primary"
                   :size="GLOBAL.config.systemSize"
                   style="float: left;"
                   @click="menuManager('3')">系统管理员菜单
        </el-button>
        <el-button v-if="false"
                   type="primary"
                   :size="GLOBAL.config.systemSize"
                   style="float: left;"
                   @click="menuManager('2')">镇管理员菜单
        </el-button>
        <!-- <el-button v-if="source.deleteBatch"
                   type="danger"
                   icon="el-icon-delete"
                   :size="GLOBAL.config.systemSize"
                   style="float: left;"
                   :disabled="deleteBatchList.ids.length === 0"
                   @click="deleteBatch">批量删除
        </el-button> -->
      </el-col>
    </el-row>
    <el-table style="width: 100%"
              :data="tableData"
              @selection-change="tableSelectionChange"
              element-loading-text="数据处理中...请稍等..."
              v-loading="loading">
      <el-table-column label="序号" type="index" width="50" align="center"></el-table-column>
      <!--姓名-->
      <el-table-column prop="xm" label="姓名" align="center"/>
      <el-table-column prop="sfzh" label="身份证号" align="center">
          <template slot-scope="scope">
              {{FUNCTIONS.systemFunction.returnStarInfo(4, 14, scope.row.sfzh)}}
          </template>
      </el-table-column>
      <el-table-column prop="sjh" label="手机号码" align="center"/>
      <el-table-column prop="ssqhmc" label="所属区划" align="center"/>
      <el-table-column prop="yhlx" label="角色" align="center">
        <template slot-scope="scope">
          {{roleMap.get(scope.row.yhlx)}}
        </template>
      </el-table-column>
      <el-table-column prop="cjsj" label="创建时间" :formatter="formatterTime">
      </el-table-column>
      <el-table-column prop="scope" label="操作" align="center">
        <template slot-scope="scope">
          <el-dropdown>
                <span class="el-dropdown-link operator-text">
                  选择操作<i class="el-icon-arrow-down el-icon--right"></i>
                </span>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item :icon="item.icon" v-for="item in getSource(scope.row)"
                                :key="item.method"
                                @click.native="handleCommon(item.method, scope.row)">
                {{item.title}}
              </el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      class="margin-top-10 margin-bottom-20"
      @size-change="tableSizeChange"
      @current-change="currentChange"
      :current-page="pagination.currentPage"
      :page-sizes="pagination.pageSizeList"
      :page-size="pagination.pageSize"
      :layout="pagination.layout"
      :total="pagination.total">
    </el-pagination>
    <!--操作-->
    <operationTemplate ref="operationTemplate" :refresh="getTableData"/>
  </div>
</template>
<script>
  // 替换成相应的模板
  import operationTemplate from './ZxUserOperateDialog'
  import cascader from '../../../components/Cascader'
  export default {
    name: 'ZxUserTable',
    data () {
      return {
        yhqx: JSON.parse(localStorage.getItem('gcUserInfo')).yhqx,
        // 查询表单
        searchForm: {
          // userName: '',
          // sex: '',
          // email: '',
          // phoneNumber: '',
          // status: '',
          // updateTime: '',
          // organizationId: '',
          // childrenInclude: false
          xm: '',
          sjh: '',
          sfzh: '',
          ssqh: '',
          yhlx: ''
        },
        setProps: {
          multiple: false, // 单选
          checkStrictly: true, // 父节点取消选中关联
          value: 'code',
          label: 'name',
          children: 'children',
          leaf: 'leaf'
        },
        tableData: [],
        // 字典数据
        dictionary: {
          sex: JSON.parse(unescape(localStorage.getItem(this.GLOBAL.config.dictionaryPre + this.GLOBAL.config.dictionary.sex))),
          userStatus: JSON.parse(unescape(localStorage.getItem(this.GLOBAL.config.dictionaryPre + this.GLOBAL.config.dictionary.userStatus))),
          treeData: []
        },
        // 资源权限控制，有的系统不需这么细，则全部为true
        source: {
          add: true,
          deleteBatch: true,
          infoEdit: true,
          infoView: true,
          infoDelete: true,
          resetPwd: true,
          weChat: true
        },
        // 分页参数
        pagination: {
          pageSizeList: [10, 20, 30, 40, 50],
          pageSize: 10,
          layout: 'total, sizes, prev, pager, next, jumper',
          total: 0,
          currentPage: 1
        },
        operationVisibleFlag: false,
        deleteBatchList: {
          ids: [],
          deleteFlag: false
        },
        loading: false,
        defaultProps: {
          checkStrictly: true,
          label: 'shortName',
          value: 'id',
          children: 'children',
          expandTrigger: 'hover'
        },
        rolesData: [],
        roleMap: new Map()
      }
    },
    components: {
      operationTemplate,
      cascader
    },
    mounted () {
        this.init()
        // this.getTreeByCode()
        this.getRoleData();
      // this.getTreeData()
    },
    methods: {
      menuManager: function (type) {
          if (type === '1') {
              this.menuRequest(type)
          } else {
              this.menuRequest(type)
          }
      },
      menuRequest: function (type) {
          let _this = this
          let menuIds = ''
          let requestTitle = ''
          let yhqx = ''
          if (type === '1') {
              yhqx = '3'
              requestTitle = '是否生成县级管理员菜单？'
              menuIds = '1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20,21,23,24,25,27,28'
          } else if (type === '3') {
              yhqx = '5'
              requestTitle = '是否生成系统管理员菜单？'
              menuIds = '1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20,21,23,24,25,26,27,28'
          } else {
              yhqx = '4'
              requestTitle = '是否生成镇级管理员菜单？'
              menuIds = '2,3,4,5,6,7,8,9,10,11,13,14,15,18,20,21,22,24,25,27,28'
          }
          let param = {
              info: {
                  id: yhqx,
                  menuList: menuIds.split(',')
              },
              baseService: 'TGcRoleServiceImpl',
              type: 'addQx'
          }
          _this.$confirm(requestTitle, '提示', {
          }).then(() => {
              _this.FUNCTIONS.systemFunction.jsonPost(
                  _this.CONFIG.urls.root + _this.CONFIG.urls.business.zxUser,
                  param,
                  resultData => {
                      _this.loading = false
                      if (resultData) {
                          _this.$message.success('菜单设置成功～')
                      } else {
                          _this.$message.warning('菜单设置失败～')
                      }
                  }
              )
          })
      },
      init: function () {
        // TODO 加载列表数据
        this.getTableData('init')
      },
      doSearch: function () {
        let code = this.$refs.myArea.sendToParent('value')
        if (code) {
          this.searchForm.ssqh = code
        } else {
          this.searchForm.ssqh = ''
        }
        this.getTableData('init')
      },
      operationMethod: function (operateType, info) {

        this.$refs.operationTemplate.init(operateType, info ? info : null)
        // this.$refs.operationTemplate.formRules()
      },
      deleteBatch: function () {
        let _this = this
        _this.$confirm('确认删除当前选择' +
          '的' + _this.deleteBatchList.ids.length + '条数据？？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          _this.loading = true
          _this.FUNCTIONS.systemFunction.interactiveData(
            _this,
            _this.GLOBAL.config.businessFlag.zxUser,
            _this.GLOBAL.config.handleType.deleteLogicalBatch,
            _this.deleteBatchList.ids,
            'list',
            resultData => {
              _this.loading = false
              if (resultData) {
                _this.$message.success('删除成功～')
                _this.getTableData('init')
              } else {
                _this.$message.warning('删除失败～')
              }
            }
          )
        })
      },
      getSource: function (rowData) {
        let tempList = []
        this.source.infoView && tempList.push({icon: 'el-icon-view', title: '查看', method: 'handleView'})
        // if (rowData.yhqx != '5') {
        //     this.source.infoEdit && tempList.push({icon: 'el-icon-edit', title: '编辑', method: 'handleEdit'})
        // }
        if (this.tableOperation(rowData)) {
            this.source.infoEdit && tempList.push({icon: 'el-icon-edit', title: '编辑', method: 'handleEdit'})
            this.source.infoDelete && tempList.push({icon: 'el-icon-delete', title: '删除', method: 'handleDelete'})
            this.source.resetPwd && tempList.push({icon: 'el-icon-edit', title: '重置密码', method: 'handleResetPwd'})
        }
        if (rowData.wxId) {
            this.source.weChat && tempList.push({icon: 'el-icon-edit', title: '解绑微信账号', method: 'handleCancelWeChat'})
        }
        return tempList
      },
      handleCommon: function (type, rowData) {
        switch (type) {
          case 'handleEdit':
            this.handleEdit(rowData)
            break
          case 'handleView':
            this.handleView(rowData)
            break
          case 'handleDelete':
            this.handleDelete(rowData)
            break
          case 'handleResetPwd':
            this.handleResetPwd(rowData)
            break
          case 'handleCancelWeChat':
            this.handleCancelWeChat(rowData)
            break
        }
      },
      // 解绑微信
      handleCancelWeChat: function(rowData) {
          let _this = this;
          this.$confirm('确定解绑当前用户微信账号？', '提示',{}).then(()=>{
              _this.updateForm(rowData)
          })
      },
        updateForm: function (rowData) {
            let _this = this;
            let params =  {
                Personnel: {
                    UUID: rowData.uuid
                }
            }
            params.baseService = "TGcUserServiceImpl";
            this.FUNCTIONS.systemFunction.interactiveData(
                _this,
                _this.GLOBAL.config.businessFlag.zxUser,
                'jbUser',
                params,
                null,
                resultData => {
                    _this.loading = false
                    if (resultData) {
                        if (resultData.code == '200') {
                            _this.$message.success('解绑成功～')
                            _this.getTableData('init')
                        } else {
                            _this.$message.warning(resultData.errorMsg)
                        }
                    } else {
                        _this.$message.warning('解绑失败～')
                    }
                },
                () => {
                    _this.$message.warning('解绑失败～请联系管理员')
                })
        },
      // 重置密码
      handleResetPwd: function(rowData) {
        let _this = this
        let param = {
            info: rowData.uuid,
            baseService: 'TGcUserServiceImpl',
            // baseService: _this.GLOBAL.config.baseServiceType.TGcGcdaServiceImpl,
            type: 'recoverPwd'
        }
        _this.$confirm('确认重置当前用户密码？', '提示', {
        }).then(() => {
            _this.FUNCTIONS.systemFunction.jsonPost(
                _this.CONFIG.urls.root + _this.CONFIG.urls.business.zxUser,
                param,
                resultData => {
                    _this.loading = false
                    if (resultData) {
                        _this.$message.success('密码重置成功～')
                        _this.getTableData('init')
                    } else {
                        _this.$message.warning('密码重置失败～')
                    }
                }
            )
        })
      },
      // 编辑
      handleEdit: function (rowData) {
        // this.operationMethod('edit', rowData)
         this.$refs.operationTemplate.init('edit', rowData);
        // TODO
      },
      // 查看
      handleView: function (rowData) {
        // this.operationMethod('view', rowData)
        this.$refs.operationTemplate.init('view', rowData);
        // TODO
      },
      // 单条数据删除
      handleDelete: function (rowData) {
        let _this = this
        let param = {
            info: rowData.uuid,
            baseService: 'TGcUserServiceImpl',
            // baseService: _this.GLOBAL.config.baseServiceType.TGcGcdaServiceImpl,
            type: _this.GLOBAL.config.handleType.deleteLogical
        }
        _this.$confirm('确认删除当前数据？？', '提示', {
        }).then(() => {
            _this.FUNCTIONS.systemFunction.jsonPost(
                _this.CONFIG.urls.root + _this.CONFIG.urls.business.zxUser,
                param,
                resultData => {
                    _this.loading = false
                    if (resultData) {
                        _this.$message.success('删除成功～')
                        _this.getTableData('init')
                    } else {
                        _this.$message.warning('删除失败～')
                    }
                }
            )
        })
      },
      // 获取列表
      getTableData: function (initPageFlag) {
        this.loading = true
        let _this = this, searchParams = this.searchForm;
        //   orgs = this.$refs.orgList.getCheckedNodes(), selectOrgName = ''
        // Object.assign(searchParams, this.searchForm)
        // if (orgs && orgs.length && (orgs.length === 1)) {
        //   selectOrgName = orgs[0].label
        // }
        // 部门查询处理
        // if (searchParams.organizationId) {
        //   searchParams.organizationId = searchParams.organizationId.join(',')
        //   if (selectOrgName) {
        //     searchParams.organizationId = searchParams.organizationId + ',' + selectOrgName
        //   }
        // }
        _this.FUNCTIONS.systemFunction.removeNullFields(searchParams)
        let paginationData = _this.FUNCTIONS.systemFunction.paginationSet(
          initPageFlag ? 1 : _this.pagination.currentPage,
          initPageFlag ? 10 : _this.pagination.pageSize,
          searchParams)
        // 3、 调接口获取数据
        paginationData.baseService = 'TGcUserServiceImpl'
        _this.FUNCTIONS.systemFunction.interactiveData(
          _this,
          _this.GLOBAL.config.businessFlag.zxUser,
          _this.GLOBAL.config.handleType.getPage,
          paginationData,
          null,
          resultData => {
            _this.loading = false
            if (resultData) {
              // 结果参数赋值
              _this.pagination.pageSize = resultData.obj.size
              _this.pagination.total = resultData.obj.total
              _this.pagination.currentPage = resultData.obj.current
              _this.tableData = resultData.obj.records
            } else {
              _this.$message.warning('获取列表数据失败～')
            }
          },
          () => {
            _this.loading = false
          }
        )
      },
      // 分页方法
      tableSizeChange: function (pageSize) {
        this.pagination.pageSize = pageSize
        this.getTableData()
      },
      currentChange: function (current) {
        this.pagination.currentPage = current
        this.getTableData()
      },
      // 复选框选择事件
      tableSelectionChange: function (targetList) {
        let ids = []
        targetList.forEach(item => {
          ids.push(item.id)
        })
        this.deleteBatchList.ids = ids
        if (this.deleteBatchList.ids &&
          this.deleteBatchList.ids.length > 0) {
          this.deleteBatchList.deleteFlag = true
        } else {
          this.deleteBatchList.deleteFlag = false
        }
      },
      // 禁用用户
      inActiveUse: function (rowData) {
        let _this = this
        !rowData.status ? this.$confirm('确定禁用该用户【' + rowData.userName + '】吗?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          f()
        }) : f()

        function f () {
          let params = {id: rowData.id, status: rowData.status ? 0 : 1}
          _this.FUNCTIONS.systemFunction.interactiveData(
            _this,
            _this.GLOBAL.config.businessFlag.zxUser,
            _this.GLOBAL.config.handleType.updateAll,
            params,
            null,
            resultData => {
              if (resultData) {
                _this.$message.success('操作成功～')
                _this.showFlag = false
                _this.getTableData('init')
              } else {
                _this.$message.warning('操作失败～')
              }
            })
        }
      },
      // 组织树数据
      getTreeData: function () {
        this.loading = true
        let _this = this
        // 3、 调接口获取数据
        _this.FUNCTIONS.systemFunction.interactiveData(
          _this,
          _this.GLOBAL.config.businessFlag.zxOrganization,
          _this.GLOBAL.config.handleType.getTree,
          null,
          null,
          resultData => {
            _this.loading = false
            if (resultData) {
              _this.dictionary.treeData = resultData
            } else {
              _this.$message.warning('获取组织数据失败～')
            }
          },
          () => {
            _this.loading = false
          }
        )
      },
      getRoleData() {
        let _this = this;
            let param = {
                baseService: 'TGcRoleServiceImpl',
                // baseService: _this.GLOBAL.config.baseServiceType.TGcOrganizationServiceImpl,
                // type: 'getTreeTwo',
                type: 'allRole',
                info: {Personnel:{term: ''}}
            }
            _this.FUNCTIONS.systemFunction.jsonPost(
                _this.CONFIG.urls.root + _this.CONFIG.urls.business.zxUser,
                param,
                resultData => {
                    if (resultData) {
                        this.rolesData = resultData.obj;
                        this.getTableData();
                        for (const e in this.rolesData) {
                          _this.roleMap.set(this.rolesData[e].uuid, this.rolesData[e].text2);
                        }
                        localStorage.setItem('roleMap', JSON.stringify(_this.rolesData))
                        let tempRoles = this.rolesData
                        if (this.yhqx === '4') {
                            this.rolesData = tempRoles.filter(item => item.uuid!='3' && item.uuid!='5')
                        } else {
                            this.rolesData = tempRoles.filter(item => item.uuid!='5' && item.uuid!='8')
                        }
                    } else {

                    }
                }
            )
      },
      formatterTime(row, column, data) {
          if (!data) {
              return "";
          }
          var reg = /(\d{4})(\d{2})(\d{2})(\d{2})(\d{2})(\d{2})/;
          return data.replace(reg, "$1-$2-$3 $4:$5:$6");
      },
      tableOperation: function (rowData) {
        if (this.yhqx == '3') {
          return (rowData.yhqx != '3' && rowData.yhqx != '5' && rowData.yhqx != '8')
        } else if (this.yhqx == '4') {
          return (rowData.yhqx != '3' && rowData.yhqx != '4' && rowData.yhqx != '5')
        } else {
          return true
        }
      },
      exportFile: function () {
        let requestBean = JSON.parse(localStorage.getItem('gcUserInfo')).ssqhdm
        let code = this.$refs.myArea.sendToParent('value')
        if (code) {
          this.searchForm.ssqh = code
        } else {
          this.searchForm.ssqh = ''
        }
        let param = this.FUNCTIONS.systemFunction.removeNullFields(this.searchForm)
        let paramsStr = '?'
        for (let key in param) {
          paramsStr = paramsStr + key + '=' + param[key] + '&'
        }
        paramsStr = paramsStr + 'requestBean=' + requestBean
        window.location.href = this.CONFIG.urls.root + '/indexCommon/exportTGcUser' + paramsStr
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/view/system/user/ZxUserTable.vue